import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clear: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'business-filters.simple-search-field.clear',
		defaultMessage: 'Clear',
		description: 'Button to clear value within search input',
	},
});
